import type { FaireProductEntity } from "../../entity_types/product";

export const p_7uehrean34: FaireProductEntity = {
  token: "p_7uehrean34",
  type: "product",
  name: "The Original Tiny Hands",
  brandToken: "b_6qajwqdzz3",
  brandName: "BigMouth Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/b29812ba375cca8913f4cf292660b60340ec1924219be3f82d1d0c1e973cb20d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c871988f6bbcb668543c7eec54cefb32118323bcc3024aaff03da14276558868.jpeg",
    "https://cdn.faire.com/fastly/52c74ad16d7d3466c57b082ccf8f37f8b126ecc9914d0ea55b5d9c93ff384abc.jpeg",
    "https://cdn.faire.com/fastly/826a32cb998ec843a34b9b7cc9138553d295dd65c5a2d8dbcd131c11cdaaadeb.jpeg",
  ],
  priceDollars: 7.61,
  description:
    "Tiny Hands equal Big laughs These ultra-realistic mini-props are a hilarious way to surprise (see also: creep out) people. Just hold onto them, and conceal your real hands. Use them in public, freak out your cat, disrupt a class—the possibilities are endless when you go “hands-on”. Whatever you do, get it on video, because it might just go viral. Don’t forget the feline version! \n * tiny, miniature hands \n * fun for all ages \n * great for videos and pranks \n * easy to use",
  tags: [],
  msrpDollars: 15.23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:24.032Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
